import { CollectionsMarketingPageLayout } from "../../pagelayouts/features/collections";
import { useMarketingPagesTracking } from "../../hooks/marketingPagesTracking";
import { GoogleTagManagerScript } from "../../tracking/GoogleTagManager/GoogleTagManagerScript";

const Curate = () => {
    useMarketingPagesTracking(true);

    return (
        <>
            <GoogleTagManagerScript />
            <CollectionsMarketingPageLayout />
        </>
    );
};

export async function getStaticProps() {
    return {
        props: {}
    };
}

export default Curate;
